import { Controller } from '@hotwired/stimulus'
import Logger from '../lib/logger'

/**
 * MapTriggerController - Simple utility to trigger map actions from outside the map scope
 * 
 * This controller dispatches custom events that the MapLeafletController listens for.
 */
export default class extends Controller {
  static values = {
    eventName: { type: String, default: 'map:activate-bid-list' }
  }

  /**
   * Dispatch the configured event to the window
   * @param {Event} event - The triggering event
   */
  trigger(event) {
    if (event) {
      // Don't prevent default as we want the link/button to still function (e.g., load Turbo frame)
      // but stop propagation if needed to avoid double triggers
      Logger.debug('Map trigger activated', { event: this.eventNameValue })
    }

    const customEvent = new CustomEvent(this.eventNameValue, {
      bubbles: true,
      cancelable: true,
      detail: { originalEvent: event }
    })
    
    window.dispatchEvent(customEvent)
  }

  /**
   * Specific helper for activating the bid list tab
   */
  activateBidList(event) {
    this.eventNameValue = 'map:activate-bid-list'
    this.trigger(event)
  }
}
